import { DayValue } from "@amir04lm26/react-modern-calendar-date-picker";
import moment from 'moment';

type DateFormat = 'iso' | 'isoDateTime' | 'time' | 'hour';

const dateFormats = {
    time: 'LT',
    hour: 'HH',
    iso: 'MM-DD-YYYY',
    isoDateTime: 'MM-DD-YYYYTHH:mm:ss',
};

export function formatDate(date: Date | string, format: DateFormat = 'iso') {
    return moment(date).format(dateFormats[format]);
};

export function fromDatePickerFormat(date: DayValue): string {
    if (!date) return '';
    return `${date.month < 10 ? `0${date.month}` : date.month}-${date.day < 10 ? `0${date.day}` : date.day}-${date?.year}`;
};

export function toDatePickerFormat(date: string | null): DayValue {
    let output = null;

    if (typeof date === 'string' && date !== '') {

        output = {
            day: Number(date?.slice(3, 5)),
            month: Number(date?.slice(0, 2)),
            year: Number(date?.slice(6))
        };
    }

    return output;
};